<template>
  <div class="product-add">

    <el-form size="small" ref="form" :model="form" label-width="200px">


        <el-form-item label="文章bannar" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.bannar">
          <transition-group>
            <div v-for="(item, index) in form.bannar" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('bannar')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>


      <!-- <el-form-item label="分享文章得积分" prop="share_article_point">
        <el-input type='number' v-model="form.share_article_point" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="开启视频奖励">
        <el-radio-group v-model="form.is_open_reward">
          <el-radio :label="1">开</el-radio>
          <el-radio :label="0">关</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="视频奖励设置：" v-if="form.is_open_reward == 1">
        <div >
          <el-table
            :data="form.gradeList"
            border
            size="mini"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="会员等级">
            </el-table-column>

            <el-table-column
              prop="video_type"
              label="奖励类型">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-radio-group  v-model="scope.row.video_type">
                    <el-radio :label="0">固定</el-radio>
                    <el-radio :label="1">随机</el-radio>
                  </el-radio-group>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="video_name"
              label="金额">
              <template v-slot="scope">
                <div class="d-s-c">
                  <span v-if="scope.row.video_type">最高数额</span>
                  <el-input v-model="scope.row.video_value"  min="0"  type="number" placeholder="请输入金额"></el-input>
                  <span class="ml10">元</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="video_limit"
              label="每天数量">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input v-model="scope.row.video_limit" min="0" type="number" placeholder="每天数量"></el-input>
                  <span class="ml10">个</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item> -->


      <!--提交-->
      <div>
        <el-button size="small" type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
      <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
  </div>
</template>

<script>
import ArticleApi from '@/api/article.js';
import Upload from "@/components/file/Upload"
export default {
    components: {
    Upload,
  },
  data() {
    return {
      /*form表单数据*/
      form: {
        share_article_point: 0,
        gradeList:[],
        is_open_reward:0,
        bannar: [],
      },
             isProductUpload:false,
      code:"album"
    };
  },
  created() {
    this.getData();
  },

  methods: {
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
    /*获取数据*/
    getData() {
      let self = this;
      ArticleApi.settingDetail({}, true)
        .then(data => {
          if(data.data.values!=[]){
            console.log(data.data.values);
            if(data.data.values!=[]){
              if (data.data.values.gradeSetting != '' && typeof data.data.values.gradeSetting != 'undefined') {
                let equitys = data.data.values.gradeSetting;
                data.data.gradeList.forEach(item => {
                  item.video_type = equitys[item.grade_id]? equitys[item.grade_id].video_type :0;
                  item.video_value =equitys[item.grade_id]? equitys[item.grade_id].video_value:0;
                  item.video_limit =equitys[item.grade_id]? equitys[item.grade_id].video_limit:0;
                });
              }
              self.form = data.data.values;
              self.form.gradeList = data.data.gradeList;

                 if(!self.form.bannar){
                  self.form.bannar = [];
                }

            }
          }

        })
        .catch(error => {});
    },
    /*转JSON字符串*/
    convertJson(list) {
      let obj = {};
      list.forEach(item => {
        obj[item.grade_id] = {
          'video_type':item.video_type,
          'video_value':item.video_value,
          'video_limit':item.video_limit,
        }
      });

      return obj;
    },
    /*提交表单*/
    onSubmit() {
      let self = this;
      let params = this.form;
      let gradeSetting={};
      params.share_article_point = self.form.share_article_point;

      self.form.gradeList.forEach(item => {
        gradeSetting[item.grade_id] = {
          'video_type':item.video_type,
          'video_value':item.video_value,
          'video_limit':item.video_limit,
        }
      });
      params.gradeSetting = gradeSetting;
      ArticleApi.editSetting(params, true)
        .then(data => {
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
          this.getData();
        })
        .catch(error => {});
    }
  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/article/setting/setting.vue